<template>
  <div>
    <div class="flexBaseline">
      <StatsBlockTitle
        title="Downloaded Packages"
        data-automation="stats-downloaded-packages-title"
        :period="period"
      />
      <Search
        :init-value="searchString"
        data-automation="stats-downloaded-packages-search"
        @searchChange="searchChange"
      />
    </div>
    <table
      class="contentListing sortableColumns"
      data-automation="stats-download-table"
    >
      <StatsTableHeader
        name-title="Package name"
        :init-sort-by="sortBy"
        :init-sort-order="sortOrder"
        @sortChange="sortChange"
      />
      <tbody>
        <tr
          v-for="p in packagesDownloaded"
          :key="p.name"
          :value="p.count"
        >
          <td>{{ p.name }}</td>
          <td>{{ p.count }}</td>
        </tr>
      </tbody>
    </table>
    <GetMoreButton
      v-if="showGetNext"
      label="List more packages"
      @getMore="getNextPackages"
    />
    <GettingMore
      :show="gettingPackagesDownloaded"
      label="Getting packages"
    />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import GettingMore from './GettingMore'
import GetMoreButton from './GetMoreButton'
import Search from './Search'
import StatsBlockTitle from './StatsBlockTitle'
import StatsTableHeader from './StatsTableHeader'

export default {
  name: 'StatsLicenses',
  components: {
    GetMoreButton,
    GettingMore,
    Search,
    StatsBlockTitle,
    StatsTableHeader,
  },
  props: {
    period: {
      type: Number,
      required: true,
    },
    sourceType: {
      type: String, // should probably be an enum. Takes values of either 'r' or 'pypi'
      required: true,
    },
  },
  data: function () {
    return {
      searchString: '',
      sortBy: 'count',
      sortOrder: 'desc',
    }
  },
  computed: {
    ...mapState({
      packagesDownloaded: state => state.stats.packagesDownloaded,
      gettingPackagesDownloaded: state => state.stats.gettingPackagesDownloaded,
      packagesDownloadedCount: state => state.stats.packagesDownloadedCount,
    }),
    showGetNext: function () {
      return !this.gettingPackagesDownloaded && (this.packagesDownloadedCount > this.packagesDownloaded.length)
    },
  },
  watch: {
    period: function (value) {
      this.getFirstPackages()
    },
    sourceType: function (value) {
      this.getFirstPackages()
    },
  },
  created: function () {
    this.getFirstPackages()
  },
  methods: {
    ...mapActions([
      'getFirstPackagesDownloaded',
      'getNextPackagesDownloaded',
    ]),
    getFirstPackages: function () {
      this.getFirstPackagesDownloaded({
        period: this.period,
        searchString: this.searchString,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        sourceType: this.sourceType,
      })
    },
    getNextPackages: function (event) {
      this.getNextPackagesDownloaded({
        period: this.period,
        searchString: this.searchString,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        sourceType: this.sourceType,
      })
    },
    searchChange: function (s) {
      this.searchString = s
      this.getFirstPackages()
    },
    sortChange: function (params) {
      this.sortBy = params.by
      this.sortOrder = params.order
      this.getFirstPackages()
    },
  },
}
</script>
